import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "nge-teams" }
const _hoisted_2 = { class: "nge-teams-intro" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-title" }, "👥 Teams", -1 /* HOISTED */)
const _hoisted_4 = { class: "nge-teams-sub" }
const _hoisted_5 = {
  key: 0,
  class: "nge-teams-empty"
}
const _hoisted_6 = {
  key: 1,
  class: "nge-teams-empty"
}
const _hoisted_7 = {
  key: 1,
  class: "nge-teams-note nge-teams-note--bad"
}
const _hoisted_8 = {
  key: 2,
  class: "nge-teams-group"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-group-label" }, "Invitations", -1 /* HOISTED */)
const _hoisted_10 = { class: "nge-teams-card-title" }
const _hoisted_11 = { class: "nge-teams-ds" }
const _hoisted_12 = { class: "nge-teams-line" }
const _hoisted_13 = { class: "nge-teams-actions" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { class: "nge-teams-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-group-label" }, "Your teams", -1 /* HOISTED */)
const _hoisted_18 = {
  key: 0,
  class: "nge-teams-empty"
}
const _hoisted_19 = { class: "nge-teams-card-title" }
const _hoisted_20 = { class: "nge-teams-ds" }
const _hoisted_21 = {
  key: 0,
  class: "nge-teams-tag nge-teams-tag--live"
}
const _hoisted_22 = { class: "nge-teams-members" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "nge-teams-name" }
const _hoisted_25 = {
  key: 0,
  class: "nge-teams-tag"
}
const _hoisted_26 = {
  key: 1,
  class: "nge-teams-tag nge-teams-tag--live"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-teams-tick",
  "aria-hidden": "true"
}, "…", -1 /* HOISTED */)
const _hoisted_28 = { class: "nge-teams-name" }
const _hoisted_29 = { class: "nge-teams-tag" }
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = ["disabled", "onClick"]
const _hoisted_32 = { class: "nge-teams-actions" }
const _hoisted_33 = ["disabled", "title", "onClick"]
const _hoisted_34 = ["aria-pressed", "disabled", "onClick"]
const _hoisted_35 = {
  key: 0,
  class: "nge-teams-line nge-teams-line--dim"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-line nge-teams-line--dim" }, "To finish, any of you completes the cell the usual way. Everyone on the team is credited.", -1 /* HOISTED */)
const _hoisted_37 = { class: "nge-teams-foot" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "nge-teams-found"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 1,
  class: "nge-teams-line nge-teams-line--dim"
}
const _hoisted_42 = {
  class: "nge-teams-open",
  title: "Shows this team under 'Teams looking for teammates', where any player with production access can ask to join. You choose who is let in."
}
const _hoisted_43 = ["checked", "disabled", "onChange"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "Looking for teammates", -1 /* HOISTED */)
const _hoisted_45 = {
  key: 1,
  class: "nge-teams-line nge-teams-line--dim"
}
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = { class: "nge-teams-card-title" }
const _hoisted_48 = { class: "nge-teams-ds" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-line nge-teams-line--dim" }, "You asked to join. The team will answer when they are next in the game.", -1 /* HOISTED */)
const _hoisted_50 = { class: "nge-teams-actions" }
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = { class: "nge-teams-group" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-group-label" }, "Start a team", -1 /* HOISTED */)
const _hoisted_54 = { class: "nge-teams-card nge-teams-card--new" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-line" }, [
  /*#__PURE__*/_createTextVNode("Show the one cell you want to work on, then start a team on it. You can also press "),
  /*#__PURE__*/_createElementVNode("b", null, "Team up"),
  /*#__PURE__*/_createTextVNode(" on a cell you have claimed in My Cells.")
], -1 /* HOISTED */)
const _hoisted_56 = { class: "nge-teams-new" }
const _hoisted_57 = ["onKeydown"]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "nge-teams-group" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "nge-teams-group-label" }, "Teams looking for teammates", -1 /* HOISTED */)
const _hoisted_61 = {
  key: 0,
  class: "nge-teams-empty"
}
const _hoisted_62 = { class: "nge-teams-card-title" }
const _hoisted_63 = { class: "nge-teams-ds" }
const _hoisted_64 = { class: "nge-teams-line" }
const _hoisted_65 = { class: "nge-teams-actions" }
const _hoisted_66 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, "Two to " + _toDisplayString($setup.teamsState.max) + " players on one cell, each working when they can. Marks and chat are kept for the team. When anyone completes the cell, everyone on the team gets it.", 1 /* TEXT */)
    ]),
    (!$setup.teamsState.installed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Teams are not switched on yet. They will appear here soon."))
      : (!$setup.allowed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Teams are for players with production access. Finish the Sandbox to get it."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            ($setup.note)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["nge-teams-note", { 'nge-teams-note--bad': $setup.noteBad }]),
                  role: "status"
                }, _toDisplayString($setup.note), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            ($setup.teamsState.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.teamsState.error), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Invitations to answer. "),
            ($setup.invitations.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invitations, (t) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: t.id,
                      class: "nge-teams-card nge-teams-card--invite"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createTextVNode(_toDisplayString($setup.titleOf(t)) + " ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_11, _toDisplayString($setup.datasetName(t)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString($setup.joined(t).map(m => m.name).join(', ')) + " " + _toDisplayString($setup.joined(t).length === 1 ? 'invites' : 'invite') + " you to work on this cell together.", 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "nge-teams-btn nge-teams-btn--go",
                          disabled: !!$setup.busy,
                          onClick: $event => ($setup.run('yes' + t.id, () => $setup.answerInvite(t.id, true), 'You are on the team.'))
                        }, "Join the team", 8 /* PROPS */, _hoisted_14),
                        _createElementVNode("button", {
                          type: "button",
                          class: "nge-teams-btn",
                          disabled: !!$setup.busy,
                          onClick: $event => ($setup.run('no' + t.id, () => $setup.answerInvite(t.id, false)))
                        }, "No thanks", 8 /* PROPS */, _hoisted_15)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" The teams this player is on. "),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              ($setup.teamsState.loaded && !$setup.mine.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, "You are not on a team yet. Start one below, or press Team up on a cell you have claimed."))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mine, (t) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: t.id,
                  class: _normalizeClass(["nge-teams-card", { 'nge-teams-card--live': $setup.live.saved === t.id }])
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString($setup.titleOf(t)) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_20, _toDisplayString($setup.datasetName(t)), 1 /* TEXT */),
                    ($setup.live.saved === t.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "open now"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("ul", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.joined(t), (m) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: m.id,
                        title: m.partDone ? m.name + ' has marked their part done' : m.name + ' is still working'
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["nge-teams-tick", { 'nge-teams-tick--on': m.partDone }]),
                          "aria-hidden": "true"
                        }, _toDisplayString(m.partDone ? '✓' : '·'), 3 /* TEXT, CLASS */),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(m.name), 1 /* TEXT */),
                        (m.id === $setup.myId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "you"))
                          : _createCommentVNode("v-if", true),
                        ($setup.live.saved === t.id && m.id !== $setup.myId && $setup.live.members.some(x => x.id === m.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "here now"))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_23))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waiting(t), (m) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: 'w' + m.id,
                        class: "nge-teams-waiting"
                      }, [
                        _hoisted_27,
                        _createElementVNode("span", _hoisted_28, _toDisplayString(m.name), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(m.state === 'invited' ? 'invited' : 'asked to join'), 1 /* TEXT */),
                        (m.state === 'requested')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "nge-teams-mini",
                                disabled: !!$setup.busy,
                                onClick: $event => ($setup.run('ok' + t.id + m.id, () => $setup.answerRequest(t.id, m.id, true), m.name + ' is on the team.'))
                              }, "Let in", 8 /* PROPS */, _hoisted_30),
                              _createElementVNode("button", {
                                type: "button",
                                class: "nge-teams-mini",
                                disabled: !!$setup.busy,
                                onClick: $event => ($setup.run('nok' + t.id + m.id, () => $setup.answerRequest(t.id, m.id, false)))
                              }, "Not now", 8 /* PROPS */, _hoisted_31)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-teams-btn nge-teams-btn--go",
                      disabled: !!$setup.busy || !!$setup.cannotOpen(t),
                      title: $setup.cannotOpen(t) || 'Go to the cell with the team\'s marks and chat. Teammates who are in the game now work with you live.',
                      onClick: $event => ($setup.open(t))
                    }, _toDisplayString($setup.busy === 'open' + t.id ? 'Opening…' : $setup.live.saved === t.id ? 'Go to the cell' : 'Open the cell'), 9 /* TEXT, PROPS */, _hoisted_33),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["nge-teams-btn", { 'nge-teams-btn--on': $setup.myPartDone(t) }]),
                      "aria-pressed": $setup.myPartDone(t) ? 'true' : 'false',
                      disabled: !!$setup.busy,
                      title: "Tells your teammates you have finished the part you were working on. It does not complete the cell.",
                      onClick: $event => ($setup.run('part' + t.id, () => $setup.setPartDone(t.id, !$setup.myPartDone(t))))
                    }, _toDisplayString($setup.myPartDone(t) ? '✓ My part is done' : 'My part is done'), 11 /* TEXT, CLASS, PROPS */, _hoisted_34)
                  ]),
                  ($setup.cannotOpen(t))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($setup.cannotOpen(t)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    ($setup.places(t) > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ($setup.invitingFor !== t.id)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "nge-teams-mini",
                                onClick: $event => {$setup.invitingFor = t.id; $setup.query = ''}
                              }, "+ Invite a player", 8 /* PROPS */, _hoisted_38))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query) = $event)),
                                  class: "nge-teams-input",
                                  placeholder: "Player name",
                                  "aria-label": "Player to invite",
                                  onKeydown: [
                                    _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                    _cache[4] || (_cache[4] = _withKeys(_withModifiers($event => {$setup.invitingFor = ''; $setup.query = ''}, ["stop"]), ["esc"]))
                                  ],
                                  onKeyup: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                                  onKeypress: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                  [_vModelText, $setup.query]
                                ]),
                                ($setup.found.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.found, (u) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: u.id,
                                          type: "button",
                                          class: "nge-teams-mini",
                                          onClick: $event => ($setup.invite(t, u))
                                        }, _toDisplayString(u.username || u.display_name), 9 /* TEXT, PROPS */, _hoisted_40))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                  : ($setup.query.trim().length >= 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, "No player by that name."))
                                    : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */)),
                          _createElementVNode("label", _hoisted_42, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: t.open,
                              disabled: !!$setup.busy,
                              onChange: $event => ($setup.run('open?' + t.id, () => $setup.setTeamOpen(t.id, !t.open)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_43),
                            _hoisted_44
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("span", _hoisted_45, "The team is full (" + _toDisplayString($setup.teamsState.max) + " players).", 1 /* TEXT */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-teams-mini nge-teams-mini--leave",
                      disabled: !!$setup.busy,
                      onClick: $event => ($setup.leave(t))
                    }, "Leave", 8 /* PROPS */, _hoisted_46)
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.asked, (t) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: t.id,
                  class: "nge-teams-card nge-teams-card--asked"
                }, [
                  _createElementVNode("div", _hoisted_47, [
                    _createTextVNode(_toDisplayString($setup.titleOf(t)) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_48, _toDisplayString($setup.datasetName(t)), 1 /* TEXT */)
                  ]),
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-teams-mini",
                      disabled: !!$setup.busy,
                      onClick: $event => ($setup.run('undo' + t.id, () => $setup.leaveSavedTeam(t.id)))
                    }, "Take it back", 8 /* PROPS */, _hoisted_51)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createCommentVNode(" Start one on the cell in view. "),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.newTitle) = $event)),
                    class: "nge-teams-input",
                    maxlength: "80",
                    placeholder: "A name for it (optional)",
                    "aria-label": "A name for the team",
                    onKeydown: [
                      _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                      _withKeys(_withModifiers($setup.startFromView, ["prevent","stop"]), ["enter"])
                    ],
                    onKeyup: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_57), [
                    [_vModelText, $setup.newTitle]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nge-teams-btn nge-teams-btn--go",
                    disabled: !!$setup.busy,
                    onClick: $setup.startFromView
                  }, _toDisplayString($setup.busy === 'new' ? 'Starting…' : 'Team up on this cell'), 9 /* TEXT, PROPS */, _hoisted_58)
                ])
              ])
            ]),
            _createCommentVNode(" Teams anyone can ask to join. "),
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              ($setup.teamsState.loaded && !$setup.teamsState.open.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, "None right now."))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.teamsState.open, (t) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: t.id,
                  class: "nge-teams-card"
                }, [
                  _createElementVNode("div", _hoisted_62, [
                    _createTextVNode(_toDisplayString($setup.titleOf(t)) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_63, _toDisplayString($setup.datasetName(t)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_64, _toDisplayString($setup.joined(t).map(m => m.name).join(', ')) + " · " + _toDisplayString($setup.places(t)) + " " + _toDisplayString($setup.places(t) === 1 ? 'place' : 'places') + " left", 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-teams-btn nge-teams-btn--go",
                      disabled: !!$setup.busy,
                      onClick: $event => ($setup.run('ask' + t.id, () => $setup.askToJoin(t.id), 'Asked. The team will answer when they are next in the game.'))
                    }, "Ask to join", 8 /* PROPS */, _hoisted_66)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 64 /* STABLE_FRAGMENT */))
  ]))
}